import { z } from "zod";

export enum MessageDTOType {
  TEXT = "TEXT",
  DOCUMENT = "DOCUMENT",
}

export enum MessageSenderType {
  USER = "USER",
  BOT = "BOT",
}

export const MessageDTO = z.object({
  id: z.string(),
  messageType: z.nativeEnum(MessageDTOType),
  sender: z.string(),
  creationDate: z
    .string()
    .transform((date) => new Date(date))
    .or(z.date()),
  replyToMessageId: z.string().optional(),
  text: z.string().optional(),
  documentName: z.string().optional(),
  documentUrl: z.string().optional(),
  action: z
    .object({
      type: z.string(),
      data: z.record(z.unknown()).optional(),
    })
    .optional(),
  feedback: z.union([z.literal(1), z.literal(-1), z.literal(0)]).nullable().optional(),
});

export const TextMessageDTO = MessageDTO.extend({
  text: z.string(),
});

export const DocumentMessageDTO = MessageDTO.extend({
  documentName: z.string(),
  documentUrl: z.string(),
});

export type Message = z.infer<typeof MessageDTO>;
export type TextMessage = z.infer<typeof TextMessageDTO>;
export type DocumentMessage = z.infer<typeof DocumentMessageDTO>;
